import React, { useEffect } from 'react'
import Helmet from 'components/utilities/Helmet'
import { SCREEN_TITLES } from 'utils/navigation'
import { useAppSelector } from 'hooks/redux'
import styles from './style'
import BoxBalanceInvestments from './BoxBalances'
import { View } from 'react-native'
import BoxMovementsInvestments from './BoxMovements'
import { useDispatch } from 'react-redux'
import {
  getFund,
  getHoldingAccount,
  getInvestmentClient,
  getLastPerformance,
  getOrders
} from 'store/investments/thunks'
import BoxStatus from './BoxStatus'
import { InvestmentStatus } from './types'
import InvestmentsHome from 'assets/skeletons/InvestmentsHome'
import { getUserBalance } from 'store/transfers/thunks'

const Investments: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getLastPerformance())
    dispatch(getFund())
    dispatch(getHoldingAccount())
    dispatch(getInvestmentClient())
    dispatch(getOrders())
    dispatch(getUserBalance())
  }, [dispatch])

  const { isLoading } = useAppSelector(state => state.transfers)
  const { investmentClient, investmentClientLoading } = useAppSelector(
    state => state.investments
  )
  const clientStatus = investmentClient?.statusId

  if (isLoading || investmentClientLoading) {
    return <InvestmentsHome />
  }

  return (
    <>
      <Helmet title={SCREEN_TITLES.INVESTMENTS} />
      <View style={styles.container}>
        <BoxBalanceInvestments />
        {clientStatus === InvestmentStatus.APPROVED
          ? <BoxMovementsInvestments />
          : <BoxStatus statusId={clientStatus} />}
      </View>
    </>
  )
}

export default Investments
